import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Layout/Navbar"; // Import your nav
import RoutesFile from "./routes";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navbar />

        <RoutesFile />
      </AuthProvider>
    </Router>
  );
}

export default App;
